import { state as stateApp } from "../app.logic";
import { closest } from "./dom";
import moment from "moment";

setInterval(() => {
    const monthLabels = [...document.querySelectorAll(".ant-calendar-month-select:not(.custom)")];
    const yearLabels = [...document.querySelectorAll(".ant-calendar-year-select:not(.custom)")];

    const yearButtons = [...document.querySelectorAll(".ant-calendar-year-panel-year:not(.custom)")];

    const yearBetweenLabels = [...document.querySelectorAll(".ant-calendar-year-panel-decade-select-content:not(.custom)")];

    const yearBetweenButtons = [...document.querySelectorAll(".ant-calendar-decade-panel-decade:not(.custom)")];

    const yearCenturyLabels = [...document.querySelectorAll(".ant-calendar-decade-panel-century:not(.custom)")];

    const yearInputs = [
        ...document.querySelectorAll(".ant-calendar-input:not(.custom)"),
        ...document.querySelectorAll(".ant-calendar-picker-input:not(.custom)"),
    ];

    const inputWrap = [...document.querySelectorAll(".ant-calendar-input-wrap div")];

    monthLabels.forEach((d) => {
        d.style.display = "none";
        let shadow = d.nextElementSibling;
        if (shadow && shadow.hasAttribute("ad-year")) {
            d.nextElementSibling.remove();
        }
        shadow = d.cloneNode(true);
        shadow.setAttribute("ad-year", true);
        shadow.style.display = "inline-block";
        shadow.classList.add("custom");
        d.after(shadow);
    });

    yearLabels.forEach((d) => {
        d.style.display = "none";
        let shadow = null;
        if (!d.hasAttribute("ad-year")) {
            d.setAttribute("ad-year", true);
            shadow = d.cloneNode(true);
            shadow.style.display = "inline-block";
            shadow.classList.add("custom");
            d.after(shadow);
        } else {
            shadow = d.nextElementSibling;
        }
        let year = d.innerHTML;
        if (stateApp.locale === "th") {
            year = parseInt(year) + 543;
        }
        shadow.innerHTML = year;
    });

    yearButtons.forEach((d) => {
        d.style.display = "none";
        let shadow = null;
        if (!d.hasAttribute("ad-year")) {
            d.setAttribute("ad-year", true);
            shadow = d.cloneNode(true);
            shadow.style.display = "inline-block";
            shadow.classList.add("custom");
            d.after(shadow);
        } else {
            shadow = d.nextElementSibling;
        }
        let year = d.innerHTML;
        if (stateApp.locale === "th") {
            year = parseInt(year) + 543;
        }
        shadow.innerHTML = year;
    });

    yearBetweenLabels.forEach((d) => {
        const yearDoms = document.querySelectorAll(".ant-calendar-year-panel-year.custom");
        d.style.display = "none";
        let shadow = null;
        if (!d.hasAttribute("ad-year")) {
            d.setAttribute("ad-year", true);
            shadow = d.cloneNode(true);
            shadow.style.display = "inline-block";
            shadow.classList.add("custom");
            shadow.onclick = () => d.click();
            d.after(shadow);
        } else {
            shadow = d.nextElementSibling;
        }
        const first = yearDoms[1].innerHTML;
        const last = yearDoms[10].innerHTML;
        shadow.innerHTML = first + "-" + last;
    });

    yearBetweenButtons.forEach((d) => {
        d.style.display = "none";
        let shadow = null;
        if (!d.hasAttribute("ad-year")) {
            d.setAttribute("ad-year", true);
            shadow = d.cloneNode(true);
            shadow.style.display = "inline-block";
            shadow.classList.add("custom");
            d.after(shadow);
        } else {
            shadow = d.nextElementSibling;
        }
        let text = d.innerHTML.split("-");
        let first = text[0];
        let last = text[1];
        if (stateApp.locale === "th") {
            first = parseInt(first) + 543;
            last = parseInt(last) + 543;
        }
        shadow.innerHTML = first + "-" + last;
    });

    yearCenturyLabels.forEach((d) => {
        const yearDoms = document.querySelectorAll(".ant-calendar-decade-panel-decade.custom");
        d.style.display = "none";
        let shadow = null;
        if (!d.hasAttribute("ad-year")) {
            d.setAttribute("ad-year", true);
            shadow = d.cloneNode(true);
            shadow.style.display = "inline-block";
            shadow.classList.add("custom");
            shadow.onclick = () => d.click();
            d.after(shadow);
        } else {
            shadow = d.nextElementSibling;
        }
        const first = yearDoms[1].innerHTML.split("-")[0];
        const last = yearDoms[10].innerHTML.split("-")[1];
        shadow.innerHTML = first + "-" + last;
    });

    yearInputs.forEach((d) => {
        d.style.display = "none";
        let shadow = null;
        if (!d.hasAttribute("ad-year")) {
            d.setAttribute("ad-year", true);
            shadow = d.cloneNode(true);
            shadow.style.display = "inline-block";
            shadow.classList.add("custom");
            d.after(shadow);
        } else {
            shadow = d.nextElementSibling;
        }
        let value = d.value;
        const format = [...closest(d, ".custom-format").classList].find((d) => d.startsWith("format-")).replace("format-", "");
        const momentValue = moment(value, format, true);
        if (momentValue.isValid()) {
            if (stateApp.locale === "th") {
                value = momentValue.add(543, "years").format(format);
            }
        }
        shadow.value = value;
    });

    inputWrap.forEach((d) => {
        d.style.display = "none";
    });
}, 50);
